import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import PrizeRow from "./PrizeRow";
import { PRIZE_ROWS, PRIZE_SLOT_COUNTS, REGION_META, WEEKDAYS_VN } from "./constants";

dayjs.extend(utc);

const formatDrawDate = (iso, fallback) => {
  const raw = iso || fallback;
  const d = /^\d{4}-\d{2}-\d{2}$/.test(String(raw || "")) ? dayjs(raw) : dayjs.utc(raw);
  if (!d.isValid()) return "";
  return `${WEEKDAYS_VN[d.day()]}, ${d.format("DD/MM/YYYY")}`;
};

export default function LotteryResultTable({
  region,
  results = [],
  date,
  loading = false,
  titleOverride,
  liveDrawing = false,
}) {
  const meta = REGION_META[region];
  const slots = PRIZE_SLOT_COUNTS[region] || {};
  const rows = PRIZE_ROWS.filter((row) => !row.regions || row.regions.includes(region)).map(
    (row) => {
      if (region === "MB" && row.key === "prize7") {
        return { ...row, size: "xl" };
      }
      return row;
    }
  );

  const headerDate = formatDrawDate(results[0]?.drawDate, date);
  const titleName = titleOverride || meta.label;

  return (
    <section id={`kqxs-${region}`} className={`xoso-kqxs${liveDrawing ? " is-live" : ""}`}>
      <div className="xoso-kqxs__title">
        KẾT QUẢ XỔ SỐ <span className="xoso-kqxs__province">{titleName}</span>
        {headerDate ? ` - ${headerDate}` : ""}
        {liveDrawing ? (
          <span className="xoso-kqxs__live">
            <span className="xoso-kqxs__live-dot" />
            Đang xổ
          </span>
        ) : null}
      </div>
      <div className={`xoso-kqxs__wrap${loading ? " is-loading" : ""}`}>
        {!loading && !results.length ? (
          <div className="xoso-kqxs__empty">Chưa có kết quả ngày {dayjs(date).format("DD/MM/YYYY")}</div>
        ) : (
          <table className="xoso-kqxs__table">
            {results.length > 1 ? (
              <thead>
                <tr>
                  <th />
                  {results.map((item) => (
                    <th key={item.id || item.province?.code}>{item.province?.name}</th>
                  ))}
                </tr>
              </thead>
            ) : null}
            <tbody>
              {rows.map((row) => (
                <PrizeRow
                  key={row.key}
                  label={row.label}
                  shortLabel={row.shortLabel}
                  size={row.size}
                  liveDrawing={liveDrawing}
                  expectedCount={slots[row.key] || 0}
                  cells={
                    results.length
                      ? results.map((item) => item?.prizes?.[row.key] || [])
                      : [[]]
                  }
                />
              ))}
            </tbody>
          </table>
        )}
      </div>
      <div className="xoso-kqxs__end" />
    </section>
  );
}
